import React, { useState } from "react";
import styled from "styled-components";
import Top10Chart from "./Top10Chart";
import SubmissionTable from "./SubmissionTable";
import HomeEngagementChart from "../reuseableComponents/HomeEngagementChart";
import BreakdownTable from "./BreakdownTable";
import VendorHomeHero from "./VendorHomeHero";
import PrivateHeader from "../../../../components/PrivateHeader";
import EngagementTypeSelect from "../../reports/reuseableComponents/EngagementTypeSelect";
import { ENGAGEMENT_TYPES } from "../../../../storage/constants";
import { getMostRecentSub } from "../utils";
import { Book, Briefcase } from "react-feather";

const Spacer = styled.div`
  height: 16px;
`;

const ChartsWrapper = styled.div`
  width: 100%;
  min-height: 400px;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
  gap: 12px;
  flex-direction: row;

  @media (max-width: 1000px) {
    flex-direction: column;
  }
`;

const getFilteredSubmissions = (submissions, engagementType) => {
  if (engagementType === ENGAGEMENT_TYPES.ALL) return submissions;

  if (engagementType === ENGAGEMENT_TYPES.ASSIGNED)
    return submissions.filter((sub) => !sub.is_follower_submission);

  if (engagementType === ENGAGEMENT_TYPES.EXTRACREDIT)
    return submissions.filter((sub) => sub.is_follower_submission);
};

const VendorHome = ({ data }) => {
  const [engagementType, setEngagementType] = useState(ENGAGEMENT_TYPES.ALL);

  const filteredSubmissions = getFilteredSubmissions(
    data.recent_submissions,
    engagementType,
  );

  const lastSubmission = getMostRecentSub(
    filteredSubmissions,
    data?.users_info,
  );

  return (
    <>
      <PrivateHeader header="Home">
        <EngagementTypeSelect
          engagementType={engagementType}
          setEngagementType={setEngagementType}
          isVendor
        />
      </PrivateHeader>
      <div style={{ minHeight: 16 }} />
      <VendorHomeHero
        data={data}
        engagementType={engagementType}
        lastSubmission={lastSubmission}
      />
      <Spacer />
      <HomeEngagementChart
        submissions={filteredSubmissions}
        isVendor
        engagementType={engagementType}
      />
      <Spacer />
      <ChartsWrapper>
        <Top10Chart
          title="Most Popular Modules"
          Icon={Book}
          companies={data.activeCompanies}
          allSubmissions={filteredSubmissions}
          metric="MODULE"
          users={data.users_info}
          engagementType={engagementType}
        />
        <Top10Chart
          title="Most Engaged Companies"
          Icon={Briefcase}
          companies={data.activeCompanies}
          allSubmissions={filteredSubmissions}
          metric="COMPANY"
          users={data.users_info}
          engagementType={engagementType}
        />
      </ChartsWrapper>
      <Spacer />
      <SubmissionTable
        submissions={filteredSubmissions}
        usersInfo={data.users_info}
        engagementType={engagementType}
      />
      <div style={{ height: 16 }} />
      <BreakdownTable
        submissions={filteredSubmissions}
        users={data.users_info}
        engagementType={engagementType}
      />
    </>
  );
};

export default VendorHome;
